import React from "react";
import { branding } from "@/config/branding";

// Official ResFil wordmark logo (served from /public). Replaces the legacy phone-icon +
// "ResFil AI" text lockup. A subtle drop-shadow keeps the white "Res" legible on light backgrounds.
export function BrandLogo({ className = "h-8" }: { className?: string }) {
  return (
    <img
      src="/resfil-logo.png"
      alt={branding.productName}
      className={`${className} w-auto object-contain`}
      style={{ filter: "drop-shadow(0 1px 1.5px rgba(15,23,42,0.35))" }}
      data-testid="brand-logo"
    />
  );
}
